import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function WhoItsFor() {
  return <Section className="bg-[#0a0a0a]" data-id="element-380">
      <div className="grid md:grid-cols-2 gap-8" data-id="element-381">
        {/* For You */}
        <div className="luxury-border p-8" data-id="element-382">
          <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#14b8a6] to-[#2dd4bf] mb-6" data-id="element-383">
            Es para ti si:
          </h3>
          <ul className="space-y-5" data-id="element-384">
            {['Quieres empezar hoy, sin sentirte "experto"', 'Te interesa un sistema simple, no teoría infinita', 'Puedes comprometerte 30 días a publicar con intención'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-385">
                <div className="w-6 h-6 rounded-lg bg-[#14b8a6]/10 border border-[#14b8a6]/20 flex items-center justify-center shrink-0 mt-0.5" data-id="element-386">
                  <Check className="text-[#14b8a6]" size={14} data-id="element-387" />
                </div>
                <span className="text-gray-300" data-id="element-388">{item}</span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="glass-card p-8 opacity-60" data-id="element-389">
          <h3 className="text-2xl font-bold text-gray-500 mb-6" data-id="element-390">
            No es para ti si:
          </h3>
          <ul className="space-y-5" data-id="element-391">
            {['Buscas atajos milagrosos', 'Quieres resultados sin publicar', 'Quieres que te "motive" en vez de darte estructura'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-392">
                <div className="w-6 h-6 rounded-lg bg-white/[0.03] border border-white/[0.06] flex items-center justify-center shrink-0 mt-0.5" data-id="element-393">
                  <X className="text-gray-500" size={14} data-id="element-394" />
                </div>
                <span className="text-gray-500" data-id="element-395">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}